export default "__VITE_ASSET__B8Mic_K0__"